import { styled } from 'parkdepot-shared/theme'

export const Wrapper = styled('div', ({ $theme }) => ({
    margin: '2rem 0',
    textAlign: 'center'
}))

export const StepText = styled('div', ({ $theme }) => ({
    ...$theme.typography.LabelSmall,
    fontWeight: 700,
    color: '#B3BBC7',
    marginBottom: '0.4rem'
}))

export const Title = styled('div', ({ $theme }) => ({
    ...$theme.typography.LabelLarge,
    fontWeight: 700
}))
